import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Co2Module } from '@cfp/ui/pipes';
import { TranslateModule } from '@ngx-translate/core';
import {
  PortfolioBuildingsRoadmapBuildingDTO,
  PortfolioBuildingsRoadmapBuildingDTORoadmapImplementedMeasures
} from 'csr-asset-app';

@Component({
  selector: 'cfp-report-building-implemented-table',
  templateUrl: 'report-building-implemented-table.html',
  styleUrls: ['../shared-styling/report-building-measure-table.scss'],
  imports: [Co2Module, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportBuildingImplementedTable {
  public readonly implementedMeasures =
    input.required<PortfolioBuildingsRoadmapBuildingDTORoadmapImplementedMeasures[]>();
  public readonly building = input.required<PortfolioBuildingsRoadmapBuildingDTO>();
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');

  protected translationKey(suffix: string): string {
    return `${this.translationKeyPrefix()}.${suffix}`;
  }
}
